import Lenis from '@studio-freight/lenis'
import Component from '../lib/Component'
import gsap from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

export default class ScrollUpDown extends Component {
    static selector = '[data-scroll]'

    initialize() {
        gsap.registerPlugin(ScrollToPlugin)

        this.document = document.documentElement || document.body

        this.$el.addEventListener('click', (e) => {
            if (this.$el.dataset.scroll == 'up') {
                gsap.to(window, {
                    scrollTo: 0,
                    duration: 1,
                })
            } else if (this.$el.dataset.scroll == 'down') {
                const toNextLinkPosTop = this.$el.getBoundingClientRect().top
                const scrollPos =
                    (window.pageYOffset || this.document.scrollTop) -
                    (this.document.clientTop || 0)

                gsap.to(window, {
                    scrollTo: {
                        y: toNextLinkPosTop + this.$el.clientHeight + scrollPos,
                    },
                })
            } else {
                gsap.to(window, {
                    scrollTo: {
                        scrollTo: this.$el.dataset.scroll,
                    },
                })
            }
        })
    }
}
